import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import { parse, stringify } from 'qs';
import PropTypes from 'prop-types';
import url from 'url';
import { isString } from 'lodash';
import crypto from 'crypto';
/**
 * Display a users Gravatar.
 *
 * @return { object } -
 */

var Gravatar = function Gravatar(_ref) {
  var alt = _ref.alt,
      title = _ref.title,
      size = _ref.size,
      user = _ref.user,
      className = _ref.className;
  var classes = classnames('woocommerce-gravatar', className, {
    'is-placeholder': !user
  });

  var getResizedImageURL = function getResizedImageURL(imageURL) {
    var parsedURL = url.parse(imageURL);
    var query = parse(parsedURL.query);
    query.s = size;
    query.d = 'mp';
    parsedURL.search = stringify(query);
    return url.format(parsedURL);
  };

  var getAvatarURLFromEmail = function getAvatarURLFromEmail(email) {
    return 'https://www.gravatar.com/avatar/' + crypto.createHash('md5').update(email).digest('hex');
  };

  var altText = alt || user && (user.display_name || user.name) || '';
  var avatarURL = 'https://www.gravatar.com/avatar/0?s=' + size + '&d=mp';

  if (user) {
    avatarURL = getResizedImageURL(isString(user) ? getAvatarURLFromEmail(user) : user.avatar_URLs[96]);
  }

  return createElement("img", {
    alt: altText,
    title: title,
    className: classes,
    src: avatarURL,
    width: size,
    height: size
  });
};

Gravatar.propTypes = {
  /**
   * The address to hash for displaying a Gravatar. Can be an email address or WP-API user object.
   */
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),

  /**
   * Text to display as the image alt attribute.
   */
  alt: PropTypes.string,

  /**
   * Text to use for the image's title
   */
  title: PropTypes.string,

  /**
   * Default 60. The size of Gravatar to request.
   */
  size: PropTypes.number,

  /**
   * Additional CSS classes.
   */
  className: PropTypes.string
};
Gravatar.defaultProps = {
  size: 60
};
export default Gravatar;
//# sourceMappingURL=index.js.map